import { ACTIONS_LICENSE } from '../_constants/license.constants';

const initialState = {
  byId: {},
};

export function licenseReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_LICENSE.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_LICENSE.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_LICENSE.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default licenseReducer;
